import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
const isVideoShare =
    (typeof window === 'object' && window.allData && window.allData.docData && window.allData.docData.isVideoShare) ||
    false;

class ShortRelate extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    secondToDate = second => {
        if (!second) return '';

        let m = Math.floor((second / 60) % 60);
        let s = Math.floor(second % 60);

        m = m.toString().length > 1 ? m : `0${m}`;
        s = s.toString().length > 1 ? s : `0${s}`;

        return `${m}:${s}`;
    };
    render() {
        const { content } = this.props;
        const gotoUrl =
            (content.url && isVideoShare
                ? `https://ishare.ifeng.com/c/vs/${content.url.split('/').pop()}`
                : content.url) || '';

        return (
            <a href={gotoUrl} className={styles.shortFeed}>
                <div className={styles.shortFeedHead}>
                    {content.logo && (
                        <LazyImg
                            placeholder="https://x0.ifengimg.com/cmpp/2020/0426/52f031671b8d7b1size1_w64_h64.png"
                            src={content.logo}
                            className={styles.shortFeedFace}
                        />
                    )}
                    {content.sourceFrom}
                </div>
                <div className={styles.shortFeedBox}>
                    <div className={styles.shortFeedText}>{content.title}</div>
                    {content.image && (
                        <div className={styles.shortFeedBorder}>
                            <LazyImg
                                placeholder="https://x0.ifengimg.com/cmpp/2020/0426/f68f2aded650800size1_w188_h126.png"
                                src={content.image}
                                className={styles.shortFeedPic}
                            />
                            {content.type === 'video' &&
                                content.duration && (
                                    <span className={styles.shortFeedIcon}>{this.secondToDate(content.duration)}</span>
                                )}
                        </div>
                    )}
                </div>
            </a>
        );
    }
}

export default ShortRelate;
